// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"LafModal_modalBackdrop__5Kxg4","modalContent":"LafModal_modalContent__x7ZxU"};